import React, { Component } from 'react';
import axios from 'axios'
import FacebookIcon from 'react-share/es/FacebookIcon'
import VKIcon from 'react-share/es/VKIcon'
import OKIcon from 'react-share/es/OKIcon'
import FacebookShareButton from 'react-share/es/FacebookShareButton'
import VKShareButton from 'react-share/es/VKShareButton'
import OKShareButton from 'react-share/es/OKShareButton'
import { withRouter } from "react-router-dom";
import Select, { components } from 'react-select'
import './response.css'
import { base } from '../../config'
import { baseHusky } from '../../config'
import { getParameterByName } from "../../helpers";
import ReactGA from 'react-ga';

import c21 from '../../cards/c21.png'
import c22 from '../../cards/c22.png'
import c23 from '../../cards/c23.png'
import c24 from '../../cards/c24.png'
import c25 from '../../cards/c25.png'
import c26 from '../../cards/c26.png'
import c27 from '../../cards/c27.png'
import c28 from '../../cards/c28.png'
import c29 from '../../cards/c29.png'
import c210 from '../../cards/c210.png'
import c211 from '../../cards/c211.png'
import c212 from '../../cards/c212.png'
import c213 from '../../cards/c213.png'
import c214 from '../../cards/c214.png'
import c215 from '../../cards/c215.png'
import c216 from '../../cards/c216.png'

const cards = [
  false, c21, c22, c23, c24, c25, c26, c27, c28, c29, c210, c211, c212, c213, c214, c215, c216,
]
var socnet = '';
var openerState = {};

class Card extends Component {
  state = {
    card: null,
    name: '',
    nameVal: '',
    animated: false,
    createdImage: null,
    token: null,
    uid: null,
    soc: null,
    random: null
  }

  componentDidMount() {

    var d = document.getElementsByTagName("body");
    d[0].className += "response";

    this.setState({random: this.randomString()})

    ReactGA.pageview(window.location.pathname + window.location.search);

    let token  = getParameterByName('token', window.location.href)
    if (!token) token = sessionStorage.getItem('token')
    const created = localStorage.getItem('cardImage')
    const uid = localStorage.getItem('cardUid')
    const card = localStorage.getItem('cardNum')

    if(window.opener != null) {

      const { card, name, nameVal, animated, createdImage, token, uid, random } = window.opener.openerState
      const shareUrl = uid ? `${base}/m/${uid}/` : `${base}/m/2${card}/?${random}`
      var vkImage = window.location.origin + createdImage ? createdImage : `https://master.mirbackend.huskyjam.com/static/cards/VK/${card}.png?${random}`

      var url = '';

      switch( window.opener.socnet ) {
        case 'VK':
          url  = 'http://vkontakte.ru/share.php?';
          url += 'url='          + encodeURIComponent(shareUrl);
          url += '&title='       + encodeURIComponent('Зафутболь открытку к 8 марта');
          url += '&image='       + encodeURIComponent(vkImage);
          // url += '&noparse=true';
        break;

        case 'FB':
          url  = 'http://www.facebook.com/sharer.php?';
          url += 'u=' + encodeURIComponent(shareUrl);
        break;

        case 'OK':
          url  = 'https://connect.ok.ru/offer';
          url += '?url=' + encodeURIComponent(shareUrl);
        break;
      }

      window.location.href = url;
    }

    if (token && uid) {
      const config =  {
        headers: {
          Authorization: 'JWT ' + token,
        },
      }
      axios.post(`${base}/m/link/`, {uid}, config).then(res => {
        console.log(res)
      }).catch(err => {
        console.error(err)

      })
    }
    this.setState({ token, createdImage: created || null, uid: uid || null })
    console.log(created)

    if (!created) {
      this.getRandomCard()
    } else {
      this.setState({card})
    }
    setTimeout(() => {
      this.setState({animated: true})
    }, 200)
  }

  goToEnd = () => {
    localStorage.removeItem('cardNum')
    localStorage.removeItem('cardUid')
    localStorage.removeItem('cardImage')
    this.props.history.push('/end')

  }

  randomString = () => {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 5; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  }

  checkShare = () => {
    const { card, uid, soc, random } = this.state
    const shareUrl = uid ? `${base}/m/${uid}/` : `${base}/m/2${card}/?${random}`

    switch(soc) {
      case 'FB':
        axios.get(`${baseHusky}/share/count/?social=fb&url=${shareUrl}`).then(res => {
          console.log(res)
          if (res.data > 0) {
            this.goToEnd()
          }
        }).catch((err) => {
          console.error(err)
        })
        break;
      case 'OK':
        axios.get(`${baseHusky}/share/count/?social=ok&url=${shareUrl}`).then(res => {
          console.log(res)
          if (res.data > 0) {
            this.goToEnd()
          }
        }).catch((err) => {
          console.error(err)
        })
        break;

      case 'VK':

          axios.get(`${baseHusky}/share/count/?social=vk&url=${shareUrl}`).then(res => {
            console.log(res)
            if (res.data > 0) {
              this.goToEnd()
            }
          }).catch((err) => {
            console.error(err)
          })
        break;
      default:
        console.error('no social')
    }

  }

  getRandomCard = () => {
    localStorage.removeItem('cardNum')
    localStorage.removeItem('cardUid')
    localStorage.removeItem('cardImage')
    this.setState({createdImage: null, uid: null})

    var num = 0;
    if(this.state.card == null) {
      num = Math.floor(Math.random() * (17 - 1) + 1);
    } else {
      num = this.state.card;
      num++;
      if(num > 17) num = 1;
    }

    window.ga('send', 'event', 'link', 'click', 'Get random card');
    
    this.setState({
      card: num,
    })
  }

  clickShare = (name) => {
    this.setState({soc: name})
    window.ga('send', 'event', 'link', 'click', 'Socnet share ' + name);
  }

  clickSocnet = (name) => {

    window.ga('send', 'event', 'link', 'click', 'Socnet auth ' + name);

    window.openerState = this.state;

    var url = '';
    switch(name) {
      case 'VK': url = "https://master.mirbackend.huskyjam.com/login/vk-oauth2"; break;
      case 'FB': url = "https://master.mirbackend.huskyjam.com/login/facebook"; break;
      case 'OK': url = "https://master.mirbackend.huskyjam.com/login/odnoklassniki-oauth2"; break;
    }

    window.open(url,'','toolbar=0,status=0,width=626,height=436');
  }

  clickSocnetVK = (e) => {
    e.preventDefault();
    window.socnet = 'VK';
    this.clickSocnet('VK');
  }

  clickSocnetFB = (e) => {
    e.preventDefault();
    window.socnet = 'FB';
    this.clickSocnet('FB');
  }

  clickSocnetOK = (e) => {
    e.preventDefault();
    window.socnet = 'OK';
    this.clickSocnet('OK');
  }

  createCard = () => {

    console.log('createCard');

    const { name, card, createdImage, nameVal, random } = this.state
    this.setState({ name: nameVal })

    if (nameVal) {
      axios.post(`${baseHusky}/m/create/`, {
        card_number: card,
        name: nameVal
      }).then(res => {
        console.log(res)
        const uid = res.data.uid
        const image = res.data.image
        localStorage.setItem('cardNum', card)
        localStorage.setItem('cardUid', uid)
        localStorage.setItem('cardImage', image)
        this.setState({createdImage: image, uid})
      })
    }
    window.ga('send', 'event', 'button', 'click', 'create card');

  }

  changeHandler = (option) => {
    console.log(option.value);
    this.setState({ nameVal: option.value }, () => { 
      console.log(this.state.nameVal);
      this.createCard()
    })
  }

  render() {
    const { card, name, nameVal, animated, createdImage, token, uid, random } = this.state
    const shareUrl = uid ? `${base}/m/${uid}/` : `${base}/m/2${card}/?${random}`
    console.log('shareUrl', shareUrl)

    const customStyles = {
      container: (provided, state) => ({
        ...provided,
        width: '100%',

      }),
      control: (provided, state) => ({
        ...provided,
        borderRadius: 0,
        borderTop: state.isFocused ? 0 : 0,
        borderLeft: state.isFocused ? 0 : 0,
        borderRight: state.isFocused ? 0 : 0,
        // This line disable the blue border
        boxShadow: state.isFocused ? 0 : 0,
        '&:hover': {
          borderTop: state.isFocused ? 0 : 0,
          borderLeft: state.isFocused ? 0 : 0,
          borderRight: state.isFocused ? 0 : 0,
        },
        borderBottom: '1px solid #fff',
        borderColor: '#fff',
        minHeight: 34,
        background: 'transparent',
        width: '100%',

      }),
      indicatorSeparator: (provided, state) => ({
        ...provided,
        display: 'none'
      }),
      input: (provided, state) => ({
        ...provided,
        height: 34,
        width: '100%',
        color: '#fff',

      }),
      singleValue: (provided, state) => ({
        ...provided,
        marginTop: 4,
        color: '#fff',
      }),
      valueContainer: (provided, state) => ({
        ...provided,
        padding: '0',
        lineHeight: '27px',
        fontSize: '19px',
        color: '#fff',
        fontFamily: 'PT Sans',
      }),
      placeholder: (provided) => ({
        ...provided,
        color: '#21ffb3',
        opacity: 0.5,
      }),
      menu: (provided, state) => ({
        ...provided,
        border: 'none',
        background: '#FFFFFF',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        borderRadius: '0',
        marginLeft: '-10px',
        marginRight: '-10px',
        width: 'calc(100% + 20px)',
        zIndex: 101
      }),
      option: (provided) => ({
        ...provided,
        lineHeight: '27px',
        fontSize: '19px',
        color: '#00744e',
        fontFamily: 'PT Sans',
      }),
      dropdownIndicator: (provided) => ({
        ...provided,
        padding: 0,
        display: 'none'
      })
    }
    return (
      <div></div>
    );
  }
}

export default withRouter(Card);